<template>
  <CadastroBase
    nomePlural="PedidoMateriais"
    nomeSingular="PedidoMaterial"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-dialog
      v-model="formRemoveProduto"
      persistent
      max-width="350"
      class="dialog-deletado"
      content-class="pedido-processo-dialog"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t("Confirma_exclusao?") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            text
            @click="formRemoveProduto = false"
          >
            {{ $t("nao") }}
          </v-btn>

          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            text
            @click="removeProduto()"
          >
            {{ $t("Confirmar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="formAddProduto"
      persistent
      max-width="350"
      content-class="pedido-processo-dialog"
    >
      <v-card>
        <v-form @submit.prevent="addProduto">
          <v-card-title class="headline">
            {{ $t("Adicionar_produto") }} <br />
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              text-color="white"
            >
              {{ this.produto.descricao }}
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  type="number"
                  :label="$t('Quantidade')"
                  v-model="quantidadeSolicitada"
                  min="1"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="limpaFormProduto"
            >
              {{ $t("Cancelar") }}
            </v-btn>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click.prevent="addProduto"
            >
              {{ $t("Adicionar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-col cols="12" class="pedido-processo">
      <PedidoProcessoIntroducao
        titulo="Planeje os materiais do evento"
        descricao="Preencha as datas e o centro de custo, depois selecione os materiais e revise o pedido antes do envio."
        icon="mdi-toolbox-outline"
      />
      <v-row>
        <v-col cols="12">
          <v-text-field
            id="evento"
            v-model="descricao"
            :label="$t('Evento')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="12">
          <CampoRelacionamentoCadastroRapido
            id="selecionaEscopo"
            v-model="centroCusto"
            url="centroCustos/tipo/4"
            cadastro-url="cadastro.CentroCusto"
            :item-text="(item) => item.descricao"
            label="Centro_custo"
          />
        </v-col>

        <v-col cols="6" md="6" class="d-flex">
          <CampoData
            @date="dataPedido = $event"
            :label="$t('Data')"
            id="dataPedido"
          />
        </v-col>
        <v-col cols="6" md="6" class="d-flex">
          <CampoData
            id="dataRetorno"
            @date="dataRetorno = $event"
            :label="$t('Previsao_retorno')"
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-textarea
            v-model="observacao"
            :label="$t('Descricao_pedido_material')"
            id="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-textarea>
        </v-col>

        <PedidoProdutosSeletor
          v-model="pedido"
          :produtos="produtos"
          titulo-catalogo="Catálogo de materiais"
          product-icon="mdi-toolbox-outline"
          :mostrar-codigo-barras="true"
          :mostrar-estoque="true"
        />

        <v-col cols="12"> </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";
import PedidoProcessoIntroducao from "@/components/recursos/pedido-layout/PedidoProcessoIntroducao";
import PedidoProdutosSeletor from "@/components/recursos/pedido-layout/PedidoProdutosSeletor";
import DataService from "@/services/recursos/PedidoMaterialDataService";
export default {
  name: "CadastroPedido",
  components: {
    CadastroBase,
    CampoRelacionamentoCadastroRapido,
    PedidoProcessoIntroducao,
    PedidoProdutosSeletor,
  },
  data() {
    return {
      DataService: DataService,
      DeveLimparForm: true,
      submited: false,
      dataPedido: "",
      dataDevolucao: "",
      descricao: "",
      observacao: "",
      centroCusto: {},

      pedido: [],
      produtos: [],
      search: "",
      searchPedido: "",
      errors: [],
      produto: {},
      formAddProduto: false,
      formRemoveProduto: false,
      quantidadeSolicitada: 0,
      headers: [
        {
          text: this.$t("Descricao"),
          value: "descricao",
          align: "start",
          sortable: "false",
        },
        // { text: this.$t("Valor"), value: "valor", sortable: "true" },
        // { text: this.$t("Estoque"), value: "estoque", sortable: "true" },
        // { text: this.$t("Status"), value: "status", sortable: "false" },
      ],
      headersPedido: [
        {
          text: this.$t("Descricao"),
          value: "produto.descricao",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("quantidadeSolicitada"),
          value: "quantidadeSolicitada",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    limpaForm() {
      this.pedido = [];
      this.dataPedido = "";
      this.dataDevolucao = "";
      this.observacao = "";
      this.descricao = "";
    },

    getProdutos() {
      DataService.getProdutos().then((response) => {
        this.produtos = response.data;
      });
    },
    handleClick(event) {
      this.produto = event;
      this.formAddProduto = true;
    },
    addProduto() {
      var produtoExistente = this.pedido.find(
        (produto) => produto.produto.id == this.produto.id
      );
      if (produtoExistente) {
        this.quantidadeSolicitada =
          parseInt(this.quantidadeSolicitada) +
          parseInt(produtoExistente.quantidadeSolicitada);
        this.pedido = this.pedido.filter((produto) => {
          return produto.produto.id !== produtoExistente.produto.id;
        });
      }
      this.pedido.push({
        produto: this.produto,
        quantidadeSolicitada: this.quantidadeSolicitada,
      });
      this.produto = {};
      this.quantidadeSolicitada = 0;
      this.search = "";
      this.formAddProduto = false;
      console.log("searchProdutos", this.$refs.searchProdutos);
      this.$refs.searchProdutos.focus();
    },
    limpaFormProduto() {
      this.formAddProduto = false;
      this.quantidadeSolicitada = 0;
    },
    confirmaRemoveProduto(item) {
      this.produto = item.produto;
      this.formRemoveProduto = true;
    },
    removeProduto() {
      this.pedido = this.pedido.filter((produto) => {
        return produto.produto.id !== this.produto.id;
      });
      this.formRemoveProduto = false;
      this.$swal.fire(this.$t("Removido_com_sucesso"), "", "success");
    },
  },
  mounted() {
    this.getProdutos();
  },
  computed: {
    recurso: function () {
      return {
        dataPedido: this.dataPedido,
        dataRetorno: this.dataRetorno,
        observacao: this.observacao,
        descricao: this.descricao,
        items: this.pedido,
        centroCusto: this.centroCusto,
      };
    },

    agora: function () {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate().toString().padStart(2, "0");
      return date + "T00:00";
    },
  },
};
</script>
<style scoped>
#data {
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 99px;
}
.mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
  color: transparent;
}
input:focus::-webkit-datetime-edit {
  color: rgba(255, 255, 255, 0.46) !important;
}
</style>
